<div *ngIf="categoria" class="p-2 badge rounded-pill" 
[style.backgroundColor]="categoria.coloreSfondo"
[style.color]="categoria.coloreTesto">
  {{ categoria.nome }}
</div>